//
//
//
//

import { currencies, countries } from '~/services/constants';

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currencySymbol: '',
    };
  },
  created() {
    const locale = this.$i18n.locale;
    const currency =
      currencies[this.currency] ||
      currencies[countries[locale.split('-')[1]].currency];
    this.currencySymbol = currency.symbol;
  },
  methods: {},
};
